import React from 'react';
import styles from './AuthFooter.module.scss';

const TERMS_URL = 'https://jobbeast.org/terms-of-service';
const PRIVACY_URL = 'https://jobbeast.org/privacy-policy';
const CONTACT_URL = 'https://jobbeast.org/contact';

const AuthFooter: React.FC = () => (
  <footer className={styles.footer}>
    <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
      Terms of Service
    </a>
    <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    <a href={CONTACT_URL} target="_blank" rel="noopener noreferrer">
      Contact
    </a>
  </footer>
);

export default AuthFooter;
